import {createContext} from 'react';

import type {FormContextType, FormDataContextType} from './sharedTypes/formHelperTypes';

/**
 * React context for managing form state and validation throughout the component tree.
 * This context provides access to form values, errors, validation state, and form manipulation methods.
 * It serves as the primary communication channel between form components and their children.
 */
export const FormContext = createContext<FormContextType | null>(null);

/**
 * React context for managing multiple forms data within a single application or component tree.
 * This context allows for centralized management of form data across different form instances.
 * It provides a way to share and synchronize form data between multiple forms when needed.
 */
export const FormsDataContext = createContext<FormDataContextType | null>(null);